const GET_CATEGORY_DETAILS = "GET_CATEGORY_DETAILS";
const GET_CATEGORY_DETAILS_SUCCESS = "GET_CATEGORY_DETAILS_SUCCESS";
const GET_CATEGORY_DETAILS_FAILURE = "GET_CATEGORY_DETAILS_FAILURE";
const CLEAR_GET_CATEGORY_DETAILS = "CLEAR_GET_CATEGORY_DETAILS";

const categoryDetailsSymbols = {
  GET_CATEGORY_DETAILS_SUCCESS,
  GET_CATEGORY_DETAILS_FAILURE,
  GET_CATEGORY_DETAILS,
  CLEAR_GET_CATEGORY_DETAILS,
};
export default categoryDetailsSymbols;
